<template>
  <transition :name="animationName" mode="out-in">
    <div
      :aria-labelledby="`tab-${index}__item`"
      :aria-orientation="type"
      :id="`tab-${index}`"
      :key="index"
      :class="{ [divClass]: true, 'slds-show': show, 'slds-hide': !show }"
      role="tabpanel"
      v-show="show">

      <slot />
    </div>
  </transition>
</template>

<script>
import EventBus from '../../utils/EventBus'

export default {
  props: {
    animationName: String,
    id: [String, Number],
    index: Number,
    label: String,
    name: String,
    position: String,
    tabSetId: String,
    type: {
      type: String,
      default: 'default'
    }
  },
  data () {
    return {
      tabId: this.id !== undefined ? parseInt(this.id) : parseInt(Math.random() * 100000),
      show: this.index === 0
    }
  },
  created () {
    EventBus.$emit('register-tab', { label: this.label, id: this.tabId, name: this.name, position: this.position ? parseInt(this.position) : this.index, tabSetId: this.tabSetId })
  },
  beforeDestroy () {
    EventBus.$emit('unregister-tab', { id: this.tabId })
  },
  computed: {
    divClass () {
      if (this.type === 'vertical') {
        return 'slds-vertical-tabs__content'
      } else if (this.type === 'default') {
        return 'slds-tabs_default__content'
      } else {
        return ''
      }
    }
  }
}
</script>
